module.exports = __webpack_public_path__ + "media/images/promotions/banner-821bc2d1e71f1a8c6a12e7fe0d7faca6.svg";